// Utility functions for RawRecordsStatusTable

/**
 * Calculate percentage for progress bars
 * @param {number} value - The current value
 * @param {number} total - The total value
 * @returns {number} - The calculated percentage
 */
export const calculatePercentage = (value, total) => {
    return total > 0 ? Math.round((value / total) * 100) : 0;
};

/**
 * Renders content based on its type (JSON or plain text)
 * @param {string} content - The content to render
 * @param {object} styles - The styles to apply
 * @returns {React.ReactNode} - The rendered content
 */
export const renderContentByType = (content, styles = {}) => {
    if (!content) return null;

    try {
        // Try to parse as JSON for better display
        const parsed = JSON.parse(content);
        return {
            type: 'json',
            content: parsed
        };
    } catch (e) {
        // If not JSON, return as plain text
        return {
            type: 'text',
            content
        };
    }
}; 